import React, { useState } from "react";
import { useNavigate } from "react-router";
import * as FaIcons from "react-icons/fa";
import LeaveTypes from "./LeaveTypes";
import LeaveAllocation from "./LeaveAllocation";
import LeaveAssignment from "./LeaveAssignment";
import "./leavePolicies.css";

function LeavePolicies() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("leave_type");

  const tabs = [
    {
      id: "leave_type",
      label: "Leave Types",
      icon: <FaIcons.FaTags className="me-2" />,
      description: "Define leave categories and rules",
    },
    {
      id: "leave_allocation",
      label: "Leave Allocations",
      icon: <FaIcons.FaLayerGroup className="me-2" />,
      description: "Set branch-wise leave quotas",
    },
    {
      id: "leave_assignment",
      label: "User Assignment",
      icon: <FaIcons.FaUserCheck className="me-2" />,
      description: "Assign and manage employee leaves",
    },
  ];

  return (
    <div className="min-vh-100">
      <header className="border-bottom lp-page-header">
        <div className="container px-4 py-4">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <button
                className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                onClick={() => navigate("/manage-policies")}
              >
                <FaIcons.FaArrowLeft size={14} />
                Back
              </button>
              <div>
                <h1 className="h3 fw-bold mb-1">Leave Policies</h1>
                <p className="text-muted small mb-0">
                  Configure leave types, branch allocations, and employee entitlements
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="container px-4 py-4">
        <ul className="nav lp-tabs mb-4" role="tablist">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.id}>
              <button
                className={`nav-link d-flex align-items-center ${
                  activeTab === tab.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
                title={tab.description}
              >
                {tab.icon}
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
        {/* Tabs content */}
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab === "leave_type" ? "active" : ""}`}
          >
            {activeTab === "leave_type" && <LeaveTypes key={activeTab} />}
          </div>
          <div
            className={`tab-pane ${
              activeTab === "leave_allocation" ? "active" : ""
            }`}
          >
            {activeTab === "leave_allocation" && (
              <LeaveAllocation key={activeTab} />
            )}
          </div>
          <div
            className={`tab-pane ${
              activeTab === "leave_assignment" ? "active" : ""
            }`}
          >
            {activeTab === "leave_assignment" && (
              <LeaveAssignment key={activeTab} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeavePolicies;
